export default "__VITE_ASSET__25f890c5__"